import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);

let printLabelMixin = {
	methods: {
		printLabel: function (id = null, isYb = false) {
			this.axios.get(isYb ? `/3ds/api/label/yb/${id}` : `/3ds/api/label/${id}`)
				.then(value => {
					console.log('Label generation succeeded')
					console.log(JSON.stringify(value))
					this.labelUrl = value.data.data[0].fieldData.GlobalContainer
					this.showLabel = true
				})
				.catch(reason => {
					this.show = false;
					console.log('Label generation failed');
					this.authCheck(reason)
				})
		}
	}
};

export default printLabelMixin